import { MouseEventHandler, useCallback, useRef } from 'react';
import { useToggle } from 'react-use';
import { MdAdd } from 'react-icons/md';
import { OMSShiftCellDropdown } from '@lp/features/Scheduler/SchedulerOMS/components';
import { OMSShiftSelectPayload } from '@/api/apis/resources/schedule';

type OMSShiftEmptyCellProps = {
  onShiftChange: (shiftPayload?: OMSShiftSelectPayload) => void;
};

export const OMSShiftEmptyCell = ({ onShiftChange }: OMSShiftEmptyCellProps) => {
  const elRef = useRef<HTMLButtonElement>(null);
  const [isOpen, toggleIsOpen] = useToggle(false);

  const onCellClick: MouseEventHandler<HTMLButtonElement> = useCallback(() => {
    toggleIsOpen();
  }, [toggleIsOpen]);

  return (
    <>
      <button
        ref={elRef}
        onClick={onCellClick}
        aria-label="Add shift"
        className="flex items-center justify-center size-full rounded-lg text-base-20 border border-dashed border-base-20 opacity-0 focus:opacity-100 hover:opacity-100 transition cursor-pointer"
      >
        <MdAdd size={24} />
      </button>

      {isOpen && (
        <OMSShiftCellDropdown
          triggerRef={elRef}
          isOpen={isOpen}
          onOpenChange={toggleIsOpen}
          onShiftChange={onShiftChange}
        />
      )}
    </>
  );
};
